var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('main',[_c('router-view')],1),_c('vue-confirm-dialog',{staticClass:"custom-vue-confirm-dialog"}),_c('page-loader-cmp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }